import React, { Component } from 'react'
import '../../style/Admin/AuditTrailPage.css'
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// import BootstrapTable from 'react-bootstrap-table-next';
// import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
//
// const { ExportCSVButton } = CSVExport;

class AuditTrailPage extends Component {

    constructor(props) {
        super(props);
        this.state={
            data:[]
        }
    }
    componentDidMount() {
    }
    render() {
        // const columns = [
        //     {
        //         dataField: 'id',
        //         text: 'id'
        //     }
        // ];
        return (
            <div>
                <label className="title">
                        Audit Trail
                </label>
                <div>
                    {/*<BootstrapTable keyField='id' data={ this.state.data } columns={ columns } />*/}
                </div>
            </div>
        );
    }
}

export default AuditTrailPage ;

